// extracted by mini-css-extract-plugin
export default {"depositLimits":"DepositLimits__depositLimits--2ih","control":"DepositLimits__control--15c"};